const dateToMMDDYYYY = (dateString: Date) =>
  new Intl.DateTimeFormat('en-US').format(dateString);

export const formatDateToMMDDYYYY = (dateString: string) => {
  const date = new Date(dateString);
  return dateToMMDDYYYY(date);
};

export function formatDateToYYYYhMMhDD(date: Date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${('00' + month).slice(-2)}-${('00' + day).slice(-2)}`;
}

export function formatDateToMMhDDhYYYY(date: Date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${('00' + month).slice(-2)}-${('00' + day).slice(-2)}-${year}`;
}

const dateMonthDDcommaYearFormatter = new Intl.DateTimeFormat('en', {
  year: 'numeric',
  month: 'long',
  day: '2-digit',
});

export function formatDateMonthDDcommaYear(date: Date) {
  return dateMonthDDcommaYearFormatter.format(date);
}

export const formatDatetimeToMMDDYYY = (date: Date) => {
  const newDate = date.toString().split('T')[0];
  const formattedDate = newDate.split('-');
  return `${formattedDate[1]}-${formattedDate[2]}-${formattedDate[0]}`;
};

export function addDays(date: Date, days: number) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function getTimeWithTimezoneOffset(date: Date, timezoneOffset: number) {
  const nd = new Date(date);
  const utc = nd.getTime() + nd.getTimezoneOffset() * 60000;
  const adjustedTime = new Date(utc + 3600000 * timezoneOffset);

  const hours = adjustedTime.getHours();
  const minutes = adjustedTime.getMinutes();

  const formattedMinutes = (minutes < 10 ? '0' : '') + minutes;

  return { hours: hours, minutes: formattedMinutes };
}

export function reformatYYYYhMMhDDStringtoMMsDDsYYYY(date: string) {
  const [year, month, day] = date.split('-');
  return `${month}/${day}/${year}`;
}

export function formatDateStringToDateTimeZero(date: string) {
  return date.split('T')?.[0];
}
